import { Icon, type IconProps } from "@chakra-ui/icon";

function ContactIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g opacity="0.12">
				<path
					d="M12.4559 13.4589C11.275 14.5206 9.71299 15.1667 8.00005 15.1667C6.28711 15.1667 4.72506 14.5206 3.54425 13.4589C3.9498 12.5035 4.89667 11.8333 6.00005 11.8333H10.0001C11.1034 11.8333 12.0503 12.5035 12.4559 13.4589Z"
					fill="currentColor"
				/>
				<path
					d="M7.99998 9.50001C9.47274 9.50001 10.6666 8.3061 10.6666 6.83334C10.6666 5.36058 9.47274 4.16667 7.99998 4.16667C6.52722 4.16667 5.33331 5.36058 5.33331 6.83334C5.33331 8.3061 6.52722 9.50001 7.99998 9.50001Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M3.54418 13.4589C3.94973 12.5035 4.89659 11.8333 5.99998 11.8333H9.99998C11.1034 11.8333 12.0502 12.5035 12.4558 13.4589M10.6666 6.83333C10.6666 8.30609 9.47274 9.5 7.99998 9.5C6.52722 9.5 5.33331 8.30609 5.33331 6.83333C5.33331 5.36057 6.52722 4.16666 7.99998 4.16666C9.47274 4.16666 10.6666 5.36057 10.6666 6.83333ZM14.6666 8.5C14.6666 12.1819 11.6819 15.1667 7.99998 15.1667C4.31808 15.1667 1.33331 12.1819 1.33331 8.5C1.33331 4.8181 4.31808 1.83333 7.99998 1.83333C11.6819 1.83333 14.6666 4.8181 14.6666 8.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
}

export default ContactIcon;
